import { render } from "./Benefits.vue?vue&type=template&id=79085098&scoped=true&ts=true"
import script from "./Benefits.vue?vue&type=script&lang=ts"
export * from "./Benefits.vue?vue&type=script&lang=ts"

import "./Benefits.vue?vue&type=style&index=0&id=79085098&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79085098"]])

export default __exports__